import React, { useEffect, useRef, useState } from 'react';
import InputText from '../../../../components/inputComponents/InputText';

const Acbg = ({
  setIsFileModalOpen,
  valueList,
  statusOption,
  controller,
  isReadOnly,
}) => {
  const part = 'acbg';
  const acbg = {
    schlNm: '',
    scsbjtNm: '',
    mtcltnYr: '',
    grdtnYr: '',
    dgrNm: '',
    acbgSttsCd: '',
    atchFileId: '',
    fileList: [],
  };

  const focusInput = useRef([]);
  const [focusOn, setFocusOn] = useState(true);
  const trigger = useRef(0);

  /*입학년도, 졸업년도 선택*/
  const startYear = 1960;
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = currentYear; year >= startYear; year--) {
    years.push(year);
  }

  useEffect(() => {
    if (valueList[part]) {
      if (valueList[part].length === 0) {
        controller.append_btn(part, acbg, setFocusOn);
      } else {
        setFocusOn(false);
      }
    }
  }, [valueList]);

  useEffect(() => {
    const lng = valueList[part] && valueList[part].length;
    if (focusOn && lng > 0 && trigger.current >= 2) {
      controller.focusData(part, focusInput);
      setFocusOn(false);
    }
    trigger.current++;
  }, [valueList[part]]);

  return (
    <>
      <h3>전문가 학력사항</h3>
      <div className="tbl-wrap">
        <table className="tbl col data scroll">
          <caption>
            전문가 심사 신청 학력사항의 학교명, 학과명, 입학년도, 졸업년도,
            학위, 현상태, 증빙서류의 정보를 나타내는 표입니다.
          </caption>
          <colgroup>
            <col style={{ width: '21%' }} />
            <col style={{ width: '24%' }} />
            <col style={{ width: '11%' }} />
            <col style={{ width: '11%' }} />
            <col style={{ width: '11%' }} />
            <col style={{ width: '11%' }} />
            <col style={{ width: '11%' }} />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">학교명</th>
              <th scope="col">학과명</th>
              <th scope="col">입학년도</th>
              <th scope="col">졸업년도</th>
              <th scope="col">학위</th>
              <th scope="col">현상태</th>
              <th scope="col">증빙서류</th>
            </tr>
          </thead>
          <tbody>
            {valueList[part] &&
              valueList[part].map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td>
                    <label
                      ref={el => {
                        focusInput.current[rowIndex] = el;
                      }}
                      htmlFor={'schlNm' + rowIndex}
                      hidden
                    >
                      학교명
                    </label>
                    <InputText
                      id={'schlNm' + rowIndex}
                      model="schlNm"
                      maxLength={200}
                      value={row}
                      isReadonly={isReadOnly}
                      changeEvt={(model, value) => {
                        const updateItem = { ...row, [model]: value };
                        controller.updateList(part, rowIndex, updateItem);
                      }}
                    />
                  </td>
                  <td>
                    <InputText
                      id={'scsbjtNm' + rowIndex}
                      model="scsbjtNm"
                      maxLength={100}
                      value={row}
                      isReadonly={isReadOnly}
                      changeEvt={(model, value) => {
                        const updateItem = { ...row, [model]: value };
                        controller.updateList(part, rowIndex, updateItem);
                      }}
                    />
                  </td>
                  <td>
                    <select
                      aria-label="입학년도"
                      className="form-select sm"
                      name="mtcltnYr"
                      value={row.mtcltnYr}
                      onChange={e => {
                        const { name, value } = e.target;
                        if (row.grdtnYr && value > row.grdtnYr) {
                          e.target.value = row.mtcltnYr;
                          return;
                        }
                        const updateItem = {
                          ...row,
                          [name]: value,
                        };
                        controller.updateList(part, rowIndex, updateItem);
                      }}
                      disabled={isReadOnly}
                    >
                      <option value=""></option>
                      {years.map(year => (
                        <option label={year} key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <select
                      aria-label="졸업년도"
                      className="form-select sm"
                      name="grdtnYr"
                      value={row.grdtnYr}
                      onChange={e => {
                        const { name, value } = e.target;
                        if (row.mtcltnYr && value < row.mtcltnYr) {
                          e.target.value = row.grdtnYr;
                          return;
                        }
                        const updateItem = {
                          ...row,
                          [name]: value,
                        };
                        controller.updateList(part, rowIndex, updateItem);
                      }}
                      disabled={isReadOnly}
                    >
                      <option value=""></option>
                      {years.map(year => (
                        <option label={year} key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <select
                      aria-label="학위"
                      className="form-select sm"
                      name="dgrNm"
                      value={row.dgrNm}
                      onChange={e => {
                        const updateItem = {
                          ...row,
                          [e.target.name]: e.target.value,
                        };
                        controller.updateList(part, rowIndex, updateItem);
                      }}
                      disabled={isReadOnly}
                    >
                      <option value=""></option>
                      {statusOption['s302'].map((item, i) => (
                        <option
                          label={item.comCdNm}
                          key={i}
                          value={item.comCdNm}
                        >
                          {item.comCdNm}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <select
                      aria-label="현상태"
                      className="form-select sm"
                      name="acbgSttsCd"
                      value={row.acbgSttsCd}
                      onChange={e => {
                        const updateItem = {
                          ...row,
                          [e.target.name]: e.target.value,
                        };
                        controller.updateList(part, rowIndex, updateItem);
                      }}
                      disabled={isReadOnly}
                    >
                      <option value=""></option>
                      {statusOption['s303'].map((item, i) => (
                        <option
                          label={item.comCdNm}
                          key={i}
                          value={item.comCdNm}
                        >
                          {item.comCdNm}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    {isReadOnly &&
                      (row.fileList.length > 0 ? (
                        row.fileList.map((file, index) => (
                          <div key={index} style={{ cursor: 'pointer' }}>
                            <div
                              className="reduceFileName"
                              onClick={() => {
                                controller.downloadUploadedFile(file);
                              }}
                            >
                              {file.orgnflNm}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div>
                          <span>-</span>
                        </div>
                      ))}
                    {!isReadOnly && (
                      <button
                        type="button"
                        className="btn xsm secondary"
                        onClick={() => {
                          setIsFileModalOpen(true);
                          controller.settingRowInfo(part, row, rowIndex);
                        }}
                      >
                        첨부
                      </button>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {!isReadOnly && (
        <div className="btn-group">
          <button
            type="button"
            onClick={() => {
              controller.append_btn(part, acbg, setFocusOn);
            }}
            className="btn xsm secondary"
          >
            추가
          </button>
          <button
            type="button"
            onClick={() => controller.delete_btn(part)}
            className="btn xsm secondary"
          >
            삭제
          </button>
        </div>
      )}
    </>
  );
};

export default Acbg;
